;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="9265123f-93d7-4181-afd8-45524ad5f3fb",e._sentryDebugIdIdentifier="sentry-dbid-9265123f-93d7-4181-afd8-45524ad5f3fb")}catch(e){}}();import './_sentry-release-injection-file.js';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

export { commonjsGlobal, getDefaultExportFromCjs };
//# sourceMappingURL=_commonjsHelpers.js.map
